import { render, staticRenderFns } from "./agentLayout.vue?vue&type=template&id=3b11af2b&scoped=true&"
import script from "./agentLayout.vue?vue&type=script&lang=js&"
export * from "./agentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b11af2b",
  null
  
)

export default component.exports